import React from "react";
import { node, string } from "prop-types";

import ActionBar from "../ActionBar/ActionBar.jsx";

const propTypes = {
  children: node,
  listingUrl: string.isRequired,
  actionBarRight: node,
};

const DetailPage = props => {
  const { actionBarRight, children, listingUrl } = props;

  return (
    <div className="detail-page">
      <ActionBar
        left={
          <a
            href={listingUrl}
            className="action-bar__back-link coh-style-black"
          >
            ← Back to Listing
          </a>
        }
        right={actionBarRight}
      />
      <div className="detail-page__wrapper">
        <div className="container container--100 detail-page__content">
          {children}
        </div>
      </div>
    </div>
  );
};

DetailPage.propTypes = propTypes;
export default DetailPage;
